import { render, staticRenderFns } from "./lkuCollector.vue?vue&type=template&id=66919167&"
import script from "./lkuCollector.vue?vue&type=script&lang=js&"
export * from "./lkuCollector.vue?vue&type=script&lang=js&"
import style0 from "./lkuCollector.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports